// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Bot_wrap__jTYLV","hide":"Bot_hide__5eswb","container":"Bot_container__9joYe"};